// Entry point for the build script in your package.json
import Turbolinks from "turbolinks";
import Rails from "@rails/ujs";
// libs
import "./modules/_collapsible";
import "./modules/_data-destroy";
import "./modules/_duplicates";
import "./modules/_edit-employee";
import "./modules/_filters";
import "./modules/_open-close-all";
import "./modules/_print";
import "./modules/_toggle-achieved-by";

Rails.start();
Turbolinks.start();
